<template>
  <Card>
    <template v-slot:title> Dados do Comprador </template>
    <template v-slot:content>
      <AppForm
        ref="form"
        :rules="rules"
        :values="buyer"
        v-slot:default="{ formErrors }"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-5 p-lg-4">
            <AppFormItem :error="formErrors.name" label="Nome">
              <AutoComplete
                v-model="name"
                :suggestions="buyers"
                @complete="onSearchBuyers($event)"
                @itemSelect="onSelect($event)"
                field="name"
                dropdown
              ></AutoComplete>
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Documento" :error="formErrors.document">
              <InputText
                v-model="document"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-3 p-lg-2">
            <AppFormItem label="Data de nascimento">
              <Calendar
                v-model="birthDate"
                dateFormat="dd/mm/yy"
                showIcon
                :monthNavigator="true"
                :yearNavigator="true"
                :yearRange="birthDateRange"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Telefone">
              <InputText v-model="phone" v-mask="'(##) ####-####'" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Celular">
              <InputText v-model="cellPhone" v-mask="'(##) #####-####'" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-4">
            <AppFormItem label="Email" :error="formErrors.email">
              <InputText v-model="email" />
            </AppFormItem>
          </div>
          <!-- Dados do Endereço -->
          <div class="p-field p-col-12" style="margin-bottom: 0">
            <div class="p-card-title">Endereço</div>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="CEP">
              <InputText
                v-model="zipCode"
                v-mask="'#####-###'"
                @blur="getAddress()"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Estado">
              <AppAutoComplete
                v-model="state"
                :options="states"
                valueField="code"
              ></AppAutoComplete>
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Cidade">
              <InputText v-model="city" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Bairro">
              <InputText v-model="district" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-4">
            <AppFormItem label="Endereço">
              <InputText v-model="address" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-4 p-lg-2">
            <AppFormItem label="Numero">
              <InputText v-model="number" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-8 p-lg-2">
            <AppFormItem label="Complemento">
              <InputText v-model="complement" />
            </AppFormItem>
          </div>
        </div>
      </AppForm>
    </template>
  </Card>
  <div class="p-col-12">
    <div class="p-grid p-jc-end p-mt-2">
      <router-link tag="span" :to="{ name: 'sale.list' }">
        <Button label="Voltar" class="p-button-outlined p-mr-2" />
      </router-link>
      <Button label="Avançar" @click="nextPage()" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import { STATES, getAddress } from '../../lib/address';
import { documentRule, emailRule } from '../../lib/validationRules';
import { BuyerApi } from '../../services/api';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      states: STATES,
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
        document: documentRule(),
        email: emailRule(),
      },
      birthDateRange: `${this.$dayjs()
        .subtract(100, 'y')
        .format('YYYY')}:${this.$dayjs().format('YYYY')}`,
      buyers: [],
    };
  },
  computed: {
    ...mapFields('sale', [
      'formData.buyer',
      'formData.buyer.name',
      'formData.buyer.document',
      'formData.buyer.birthDate',
      'formData.buyer.phone',
      'formData.buyer.cellPhone',
      'formData.buyer.email',
      'formData.buyer.address.zipCode',
      'formData.buyer.address.state',
      'formData.buyer.address.city',
      'formData.buyer.address.district',
      'formData.buyer.address.address',
      'formData.buyer.address.number',
      'formData.buyer.address.complement',
    ]),
  },
  emits: ['nextPage', 'prevPage', 'changePage'],
  methods: {
    ...mapActions('sale', ['setBuyerAdress', 'setBuyer']),
    getAddress: debounce(async function fn() {
      if (this.zipCode?.length < 8) {
        return;
      }
      const address = await getAddress(this.zipCode);
      if (address) {
        this.setBuyerAdress(address);
      }
    }, 500),
    async nextPage() {
      if (await this.$refs.form.validate()) {
        this.$emit('next-page', { pageIndex: 0 });
      }
    },
    async onSearchBuyers({ query: name }) {
      const fetchResponse = await BuyerApi.fetch({
        order: 'asc',
        orderField: 'name',
        name,
      });
      this.buyers = fetchResponse.results;
    },
    onSelect(event) {
      this.setBuyer(event.value);
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (!to.name.match(/sale\.create/g) || (await this.$refs.form.validate())) {
      next();
    } else {
      next(false);
    }
  },
};
</script>